module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.d7a7293c.woff2";